/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import {
  createSlug,
  generateUniqueId,
  getErrorDetailsFn,
  getInputFieldProps,
  safeToString,
} from "../../../utils/common";
import {
  ALLOWANCE_API,
  ALLOWANCE_INITIAL_STATE,
  ALLOWANCE_INPUT_FIELDS,
} from "./allowance-constant";
import { allowanceSchema } from "./allowance-validation";
import useSnackbar from "../../../hook/use-snakbar";
import { safeString } from "../../../utils/logger";

const useAllowanceService = () => {
  const [allowanceListResponse, setAllowanceListResponse] = useState([]);
  const [loadingUi, setloadingUi] = useState(false);

  const [allowancedialogOpen, setAllowancedialogOpen] = useState(false);
  const [addAnotherAllowance, setaddAnotherAllowance] = useState(false);

  const {
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();

  const [allowance, setAllowance] = useState(ALLOWANCE_INITIAL_STATE);
  const { fetchData } = useAPIHandler();

  const [errors, setErrors] = useState({});



  

  function handleBlurFn(e, name) {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    const fieldSchema = allowanceSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
  
        context: { allowanceType: allowance.allowanceType },

      
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  }

  const handleChangeFunction = (e, name) => {
    let value = e;

  
    // if (e && e.target) {
    //   value = e.target.value;
    // }
    if (e && e.target) {
      value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    }
    let updatedState = {
      ...allowance,
      [name]: value,
    };

    if (name === ALLOWANCE_INPUT_FIELDS.addToGross.name && !value) {
      updatedState = {
        ...updatedState,
        [ALLOWANCE_INPUT_FIELDS.isEsiWages.name]: false,
        [ALLOWANCE_INPUT_FIELDS.isEpfWages.name]: false,
      };
    }

    setAllowance(updatedState);
    if (
      ALLOWANCE_INPUT_FIELDS[name].customOptions &&
      ALLOWANCE_INPUT_FIELDS[name].customOptions?.formatValueFn
    ) {
      value = ALLOWANCE_INPUT_FIELDS[name].customOptions?.formatValueFn(
        value,
        allowance
      );
    }

    setAllowance((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    const fieldSchema = allowanceSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
      context: { allowanceType: allowance.allowanceType },
    });

   
    if (!error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };
  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);

  const onSubmitHandler = async (e) => {
    e?.preventDefault();

   
    const {
      allowanceName,

      allowanceType,
      allowanceValue,
      noWorkNoPay,
      addToGross,
      isEsiWages,
      isEpfWages,
      status,
      is_default
    } = allowance;

    const trimmedallowanceName =safeToString(allowanceName).trim();
    const { error } = allowanceSchema.validate(
      {
        allowanceName: trimmedallowanceName,

        allowanceType,
        allowanceValue,
        noWorkNoPay,
        addToGross,
        isEsiWages,
        isEpfWages,
        status
      },
      {
        abortEarly: false,
        context: { allowanceType,is_default },
      }
    );

    if (error && error?.details?.length > 0) {
      const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);
    } else {
      if (allowance?.customId) {
        const filterOtherAllowance = allowanceListResponse.filter(
          (it) => it?.customId !== allowance?.customId
        );

        if (filterOtherAllowance.length > 0) {
          const duplicateAllowance = filterOtherAllowance.find(
            (it) =>
              safeString(it?.allowanceName).toLowerCase().trim() ===
              safeString(trimmedallowanceName).toLowerCase().trim()
          );

          if (duplicateAllowance?.allowanceName) {
            openSnackbar({
              message: "Allowance Name Already exits!",
              color: "danger",
            });
            return;
          }
        }

        
const allowancePayloadData=  allowanceListResponse.map((it) =>
      it?.customId === allowance?.customId
        ? {
            ...allowance,

            slug: createSlug(trimmedallowanceName),
          }
        : it
    );

    
        // setAllowanceListResponse((prev) =>
        //   prev.map((it) =>
        //     it?.customId === allowance?.customId
        //       ? {
        //           ...allowance,

        //           slug: createSlug(trimmedallowanceName),
        //         }
        //       : it
        //   )
        // );

        onSubmitApi(allowancePayloadData);
      } else {
        if (allowanceListResponse.length > 0) {
     
          const duplicateAllowance = allowanceListResponse.find(
            (it) =>
              safeString(it?.allowanceName).toLowerCase().trim() ===
              safeString(trimmedallowanceName).toLowerCase().trim()
          );
          if (duplicateAllowance) {
            openSnackbar({
              message: "Allowance Name Already exits!",
              color: "danger",
            });
            return;
          }
        }
        const allowancePayloadData=   [
          ...allowanceListResponse,

          {
            customId: generateUniqueId(),

            allowanceName: trimmedallowanceName,
            status: true,
            allowanceType,
            allowanceValue,
            noWorkNoPay,
            addToGross,
            isEsiWages,
            isEpfWages,
            slug: createSlug(trimmedallowanceName),
          },
        ]
      

        onSubmitApi(allowancePayloadData);

      }

    }
  };

  const onSubmitApi = async (payloadData) => {
    setCreateUpdateLoading(true);

    const URL = ALLOWANCE_API.ALLOWANCE_CREATE.URL;
    const METHOD = ALLOWANCE_API.ALLOWANCE_CREATE.METHOD;

    try {
      const res = await fetchData({
        data: payloadData?.map(({ customId, ...it }) => it),
        url: URL,
        method: METHOD,
      });


      
      if (!addAnotherAllowance) {
        setAllowancedialogOpen(false);
      } else {
        setAllowance(ALLOWANCE_INITIAL_STATE);
      }
      getAllowanceListFn();

      openSnackbar({
        message: "Allowance Updated succesfully!",
        color: "success",
      });
    } catch (error) {
      setCreateUpdateLoading(false);
      const { type, message, details, errorObj } = getErrorDetailsFn(error);
      openSnackbar({
        message,
        color: "danger",
      });
    } finally {
      setCreateUpdateLoading(false);
    }
  };


  async function getAllowanceListFn() {
    setloadingUi(true);
    const allAllowances = {
      masterAllowance: [],
      organizationAllowance: [],
    };

    try {
      // Fetch master allowances
      const masterData = await fetchData({
        url: ALLOWANCE_API.MASTER_ALLOWANCE_LIST.URL,
      });
      const masterAllowances =
        (await masterData?.data?.map((it) => ({
          ...ALLOWANCE_INITIAL_STATE,
          ...it,
          customId: it?.allowance_master_id,
          allowanceName: it?.allowance_master_name,
        }))) || [];

      if (masterAllowances.length > 0) {
        allAllowances.masterAllowance = masterAllowances;
      }

      // Fetch organization allowances
      const orgDtaData = await fetchData({
        url: ALLOWANCE_API.ALLOWANCE_LIST.URL,
      });
    
      allAllowances.organizationAllowance =    (await orgDtaData?.data?.allowances?.map((it) => ({
          ...ALLOWANCE_INITIAL_STATE,
          ...it,
          customId: it?.allowanceId,
        }))) || [];
      // Update state with fetched allowances
      setAllowanceListResponse([
        ...allAllowances.masterAllowance,
        ...allAllowances.organizationAllowance,
      ]);

      setloadingUi(false);

    } catch (error) {
      setloadingUi(false);

    } finally {
      setloadingUi(false);
    }
  }

  useEffect(() => {
    getAllowanceListFn();
  }, []);

  const getInputFieldPropsFn = (fieldName) => {
    const { customOptions, ...restProps } = ALLOWANCE_INPUT_FIELDS[fieldName];

    const error = safeToString(errors[fieldName]).replace(
      "value",
      allowance.allowanceType !== "fixed" ? "Percentage" : "Amount"
    );
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: allowance,
        type: ALLOWANCE_INPUT_FIELDS[fieldName].type,
        error,
        handleChangeFunction,
        handleBlurFn
      }),
    };

    return props;
  };

  return {
    allowancedialogOpen,
    setAllowancedialogOpen,
    loadingUi,
    handleChangeFunction,
    allowance,
    onSubmitHandler,
    setAllowance,
    allowanceListResponse,
    ALLOWANCE_INITIAL_STATE,
    setAllowanceListResponse,
    onSubmitApi,
    getInputFieldProps: getInputFieldPropsFn,
    addAnotherAllowance,
    setaddAnotherAllowance,
    createUpdateLoading,
    setErrors,
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
    
  };
};

export default useAllowanceService;
